import { createApp } from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import store from './store';
import router from './router';
import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';
import { installDarkModeHelper } from '@/helpers/vuetifyTheme';
import '@fontsource/roboto/100.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource/roboto/900.css';
import '@mdi/font/css/materialdesignicons.min.css';
import '@/assets/style.css';
import '@/assets/vuetify2-compat.css';

const app = createApp(App);

app.use(router);
app.use(store);
app.use(vuetify);
installDarkModeHelper(app);

const requireComponent = require.context(
  '@/components/base',
  true,
  /[A-Z]\w+\.(vue|js)$/
);

requireComponent.keys().forEach((fileName) => {
  const componentConfig = requireComponent(fileName);
  const componentName = upperFirst(
    camelCase(
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '')
    )
  );
  app.component(componentName, componentConfig.default || componentConfig);
});

if (process.env.NODE_ENV === 'development') {
  app.config.performance = true;
}

app.mount('#app');
